
import { toTitleCase } from "./stringHelpers";

export function getFirstName(username:  String) {
  return toTitleCase(username.split(' ')[0]);
}
